import { motion } from "framer-motion";
import { CAPABILITIES, STATUS_LABELS } from "../lib/about";
import { fadeUp, viewportOnce, stagger } from "../lib/motion";

const STATUS_TONES = {
    pilot: "border-white/30 text-white/85",
    dev: "border-white/20 text-mist",
    planned: "border-white/20 border-dashed text-cad",
};

const CapabilitiesSection = () => (
    <section
        data-testid="what-we-do-section"
        className="relative bg-ink py-24 lg:py-32"
    >
        <div className="mx-auto max-w-[1600px] px-6 md:px-10 lg:px-16">
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                className="flex items-center gap-6"
            >
                <p className="font-mono text-[13px] tracking-[0.3em] text-mist">
                    WHAT WE DO
                </p>
                <span className="h-px flex-1 bg-white/10" />
                <p className="font-mono text-[13px] tracking-[0.3em] text-cad">
                    01 — 09
                </p>
            </motion.div>

            <motion.h2
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                data-testid="capabilities-headline"
                className="mt-12 max-w-4xl font-display text-4xl font-semibold leading-[1.1] text-white md:text-6xl"
            >
                One connected platform. Greater visibility across your
                building journey
                <span className="text-accent">.</span>
            </motion.h2>

            <motion.p
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                className="mt-8 max-w-2xl text-[16px] leading-relaxed text-mist"
            >
                BuildEase brings together specialised construction
                intelligence capabilities designed to help homeowners
                understand different aspects of their residential construction
                projects.
            </motion.p>

            <motion.div
                variants={stagger}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                className="mt-16 grid gap-6 md:grid-cols-2 lg:grid-cols-3"
            >
                {CAPABILITIES.map((cap) => (
                    <motion.div
                        key={cap.n}
                        variants={fadeUp}
                        data-testid={`capability-card-${cap.n}`}
                        className="flex flex-col border border-white/12 bg-surface/80 px-7 py-8"
                    >
                        <div className="flex items-center justify-between gap-3">
                            <span className="font-mono text-[13px] tracking-[0.22em] text-cad">
                                {cap.n}
                            </span>
                            <span
                                className={`shrink-0 border px-2 py-0.5 font-mono text-[13px] leading-relaxed tracking-[0.18em] ${STATUS_TONES[cap.status]}`}
                            >
                                {STATUS_LABELS[cap.status]}
                            </span>
                        </div>
                        <h3 className="mt-6 flex items-start gap-2.5 font-display text-xl font-semibold leading-snug text-white">
                            <span
                                className={`mt-2.5 h-1.5 w-1.5 shrink-0 ${
                                    cap.sustainability
                                        ? "bg-emerald-400"
                                        : "bg-accent"
                                }`}
                            />
                            {cap.title}
                        </h3>
                        <p className="mt-4 flex-1 text-[15px] leading-relaxed text-mist">
                            {cap.copy}
                        </p>
                    </motion.div>
                ))}
            </motion.div>
        </div>
    </section>
);

export default CapabilitiesSection;
